import { FieldProps } from "../../../Reusables/components/InputFieldsController/InputFieldsController.utils";
import { getGeoData } from "../../../Reusables/utilities/geoDataStorage";

export const onboardingMetaData: FieldProps[] = [
  {
    id: "formName",
    type: "text",
    label: "Form Name",
    value: "",
    placeholder: "Enter form name",
    width: 30,
    validation: [
      {
        type: "required",
        message: "Form name is required",
      },
    ],
  },
  {
    id: "formPurpose",
    type: "select",
    label: "Form Purpose",
    value: "",
    width: 15,
    options: [],
    validation: [
      {
        type: "required",
        message: "Form purpose is required",
      },
    ],
  },
  {
    id: "formTemplate",
    type: "select",
    label: "Form Template",
    value: "",
    options: [],
  },
  {
    id: "formType",
    type: "select",
    label: "Form Type",
    value: "",
    width: 15,
    options: [],
    validation: [
      {
        type: "required",
        message: "Form type is required",
      },
    ],
  },
  {
    id: "lineOfService",
    type: "select",
    label: "Line of Service",
    value: "",
    width: 15,
    options: [],
    validation: [
      {
        type: "required",
        message: "Line of Service is required",
      },
    ],
  },
  {
    id: "isFinal",
    type: "checkbox",
    label: "Draft",
    value: false,
  },
];

/**
 * Converts the `Options` field in each selected field from a JSON string to a parsed array.
 * Falls back to an empty array if parsing fails or if `Options` is undefined.
 *
 * @param fields - The object containing SelectedFields and SignatureFields arrays.
 * @returns An array of parsed SelectedFields with `Options` as arrays.
 */
export const optionsConverter = async (fields: {
  SelectedFields: any;
  SignatureFields: any;
}): Promise<any[]> => {
  // Load geo datasets in parallel
  // const [zipcodes, cities, states] = await Promise.all([
  //   getGeoData("zipcodes"),
  //   getGeoData("cities"),
  //   getGeoData("states"),
  // ]);

  const parsedFields = fields.SelectedFields.map((field: any) => {
    let parsedOptions: any[] = [];

    try {
      parsedOptions = field.Options ? JSON.parse(field.Options) : [];
    } catch (err) {
      console.error(`Invalid JSON in Options for field "${field.label}"`, err);
    }

    // const label = field.label?.toLowerCase() || "";

    // if (label.includes("zip")) {
    //   parsedOptions = zipcodes;
    // } else if (label.includes("state")) {
    //   parsedOptions = states;
    // } else if (label.includes("city")) {
    //   parsedOptions = cities;
    // }

    return {
      ...field,
      Options: parsedOptions,
    };
  });

  return parsedFields;
};

